import ROUTES from "router/routes";
import { setIsAuthorized, getUserInfo } from "store/user/slice";
import { AppDispatch } from "store";
import { NavigateFunction } from "react-router-dom";

export const handleAuthSuccess = (
  token: string,
  dispatch: AppDispatch,
  navigate: NavigateFunction,
) => {
  localStorage.setItem("token", token);
  dispatch(setIsAuthorized(true));
  dispatch(getUserInfo());
  navigate(ROUTES.DASHBOARD);
};
